var startingOpacity = 0;
var transitionProperties = "transform, opacity";
var transitionEasing = "ease-in-out";
var transitionDuration = 300;
var getMicroToastTransition = function getMicroToastTransition(args) {
  var startingTransform;
  switch (args.state.placement) {
    case "top":
    case "top-start":
    case "top-end":
      startingTransform = "translateY(20px) scaleX(0.5)";
      break;
    default:
      startingTransform = "translateY(-20px) scaleX(0.5)";
      break;
  }
  return {
    entering: {
      style: {
        opacity: startingOpacity,
        transform: startingTransform
      },
      transition: {
        duration: 0,
        easing: transitionEasing,
        property: transitionProperties
      }
    },
    entered: {
      style: {
        opacity: 1,
        transform: "translate(0, 0) scale(1)"
      },
      transition: {
        duration: transitionDuration,
        easing: transitionEasing,
        property: transitionProperties
      }
    },
    exiting: {
      style: {
        opacity: startingOpacity,
        transform: startingTransform
      },
      transition: {
        duration: transitionDuration,
        easing: transitionEasing,
        property: transitionProperties
      }
    }
  };
};

export { getMicroToastTransition };
